import config from '../server.config'
import { getEnv } from './helpers/getEnv'

export const IS_DEV_BUILD = import.meta.env.DEV
export const IS_PROD_BUILD = import.meta.env.PROD

export const {
  API_BASE_URL,
  API_TOKEN,
  AUTH_URL,
  ENV: APP_ENV,
  FAST_URL,
  FIESTA_URL,
  LOGIN_URL,
  PORTAL_URL,
  OPTIMIZER_URL,
  FLOWISE_AI_API_KEY,
  GIT_COMMIT_SHA,
  FLOWISE_URL,
  INSIGHTS_REACT_URL = 'https://insights-preview.attensi.com',
} = getEnv(config)
